<div class="table-container" *ngIf="clienteID">
    <div id="mainDiv">
        <div class="p-iconField">
            <p-iconField iconPosition="right">
                <p-inputIcon class="icon-search-button" styleClass=" pi pi-search" (click)="search()" />
                <input class="input-field" [(ngModel)]="searchCodigo" (keydown)="onKeyDown($event)" type="text"
                    pInputText placeholder="Pesquisar pelo codigo do movimento" />
            </p-iconField>
        </div>

        <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"
            placeholder="Pesquisar por data" />
        <p-button styleClass="button-adicionar-x" label="Buscar" icon="pi pi-search" (click)="search()" />
    </div>
    <p-table [value]="notas" class="table-style" [customSort]="true">
        <ng-template class="ct-tr" pTemplate="header">
            <tr>
                <th>#</th>
                <th>Codigo Nota</th>
                <th>Valor Total</th>
                <th>Data da inclusão</th>
                <th>Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-nota>
            <tr>
                <td>{{ nota.id }}</td>
                <td>{{ nota.codigoNota }}</td>
                <td>{{ nota.valorTotal }}</td>
                <td>{{ nota.criadoEm }}</td>
                <td>
                    <div class="table-actions">
                        <p-button icon="pi pi-download" label="Baixar pdf"> </p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="pagination-container">
        <p-paginator (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [showFirstLastIcon]="true">
        </p-paginator>

        <span class="mx-1 text-color">Itens por página: </span>
        <p-dropdown [options]="options" optionLabel="label" optionValue="value" [(ngModel)]="rows"
            (ngModelChange)="onRowsPerPageChange()"></p-dropdown>
    </div>
</div>
